// The chart's Y axis, as on the phone (GlucoseScale.kt) and in nightscout-emailer's charts:
// a log scale from 40 to 400 mg/dL, so spikes don't squash the in-range band.

export const GLUCOSE_MIN = 40;
export const GLUCOSE_MAX = 400;
export const TARGET_LOW = 70;
export const TARGET_HIGH = 180;
export const TIGHT_HIGH = 140;
export const GLUCOSE_TICKS = [40, 55, 80, 120, 180, 260, 400] as const;

const LOG_MIN = Math.log10(GLUCOSE_MIN);
const LOG_MAX = Math.log10(GLUCOSE_MAX);

/** 0 at the bottom (40 mg/dL) to 1 at the top (400); values outside are clamped. */
export function glucoseFraction(mgdl: number): number {
  const v = Math.min(GLUCOSE_MAX, Math.max(GLUCOSE_MIN, mgdl));
  return (Math.log10(v) - LOG_MIN) / (LOG_MAX - LOG_MIN);
}

export function inRange(mgdl: number): boolean {
  return mgdl >= TARGET_LOW && mgdl <= TARGET_HIGH;
}
